import React, { useState } from "react";

import bannerImg from "../../assets/WEBINAR-RPA-banner.jpg";
import educationImg from "../../assets/c.png";

import { FaRobot, FaGraduationCap } from "react-icons/fa";

const styles = `
  .edu-header {
    display: flex;
    height: 110px;
    border-top: 1px solid #e5e5e5;
    border-bottom: 1px solid #e5e5e5;
  }

  .edu-header-left {
    flex: 1.5;
    position: relative;
    background-size: cover;
    background-position: center;
    display: flex;
    align-items: center;
    padding: 0 20px;
  }

  .edu-header-overlay {
    position: absolute;
    inset: 0;
    background: rgba(47, 183, 164, 0.7);
  }

  .edu-header-badge {
    position: relative;
    display: flex;
    align-items: center;
    gap: 12px;
    background: rgba(0, 0, 0, 0.15);
    padding: 14px 22px;
    border-radius: 6px;
    color: #fff;
    width: 100%;
    max-width: 520px;
    box-sizing: border-box;
  }

  .edu-header-icon-box {
    width: 36px;
    height: 36px;
    min-width: 36px;
    background: #1f7f73;
    border-radius: 8px;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .edu-header-badge span:first-of-type {
    font-size: 14px;
    flex: 1;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  .edu-arrow {
    margin-left: auto;
    flex-shrink: 0;
  }

  .edu-header-right {
    flex: 1;
    background: #fff;
    display: flex;
    align-items: center;
    justify-content: center;
    position: relative;
  }

  .edu-triangle-left {
    position: absolute;
    left: 0;
    top: 0;
    height: 100%;
    width: 80px;
    background: linear-gradient(135deg, #2fb7a4 30%, #2f6f9f 60%, #2f4a7f);
    clip-path: polygon(0 0, 60% 0, 0 100%);
  }

  .edu-triangle-right {
    position: absolute;
    right: 0;
    top: 0;
    height: 100%;
    width: 80px;
    background: linear-gradient(135deg, #2fb7a4 30%, #2f6f9f 60%, #2f4a7f);
    clip-path: polygon(100% 0, 100% 100%, 40% 100%);
  }

  .edu-title-group {
    display: flex;
    align-items: center;
    gap: 12px;
    z-index: 1;
  }

  .edu-title-group h2 {
    margin: 0;
    font-size: 30px;
    font-weight: 600;
    color: #243b64;
  }

  .edu-main {
    display: flex;
    padding: 60px 80px;
    gap: 60px;
    align-items: center;
  }

  .edu-img-wrapper {
    flex: 1;
  }

  .edu-img-wrapper img {
    width: 100%;
    max-width: 650px;
    display: block;
  }

  .edu-accordion {
    flex: 1.2;
  }

  .edu-accordion-item {
    margin-bottom: 18px;
  }

  .edu-accordion-header {
    background: linear-gradient(90deg, #2fb7a4 0%, #2f6f9f 60%, #2f4a7f 100%);
    color: #f4f7fb;
    padding: 8px 24px;
    cursor: pointer;
    font-weight: 600;
    display: flex;
    justify-content: space-between;
    align-items: center;
    user-select: none;
  }

  .edu-accordion-arrow {
    font-size: 22px;
    flex-shrink: 0;
    margin-left: 12px;
  }

  .edu-accordion-body {
    padding: 20px;
    color: #555;
  }

  /* ── Tablet (≤ 1024px) ── */
  @media (max-width: 1024px) {
    .edu-header {
      height: auto;
      min-height: 90px;
    }

    .edu-header-badge {
      max-width: 100%;
      padding: 10px 14px;
    }

    .edu-title-group h2 {
      font-size: 26px;
    }

    .edu-main {
      padding: 40px 40px;
      gap: 40px;
    }
  }

  /* ── Small tablet / large phone (≤ 768px) ── */
  @media (max-width: 768px) {
    .edu-header {
      flex-direction: column;
      height: auto;
    }

    .edu-header-left {
      flex: none;
      min-height: 70px;
      padding: 12px 16px;
    }

    .edu-header-right {
      flex: none;
      min-height: 70px;
      padding: 12px 16px;
    }

    .edu-triangle-left,
    .edu-triangle-right {
      width: 50px;
    }

    .edu-title-group h2 {
      font-size: 22px;
    }

    .edu-main {
      flex-direction: column;
      padding: 30px 20px;
      gap: 30px;
    }

    .edu-img-wrapper {
      width: 100%;
    }

    .edu-img-wrapper img {
      max-width: 100%;
    }

    .edu-accordion {
      width: 100%;
    }
  }

  /* ── Mobile (≤ 480px) ── */
  @media (max-width: 480px) {
    .edu-header {
      flex-direction: column;
      height: auto;
    }

    .edu-header-left {
      min-height: 60px;
      padding: 10px 12px;
    }

    .edu-header-badge {
      padding: 10px 12px;
      gap: 8px;
    }

    .edu-header-badge span:first-of-type {
      font-size: 12px;
    }

    .edu-header-icon-box {
      width: 30px;
      height: 30px;
      min-width: 30px;
    }

    .edu-header-right {
      min-height: 60px;
      padding: 10px 12px;
    }

    .edu-triangle-left,
    .edu-triangle-right {
      width: 36px;
    }

    .edu-title-group h2 {
      font-size: 18px;
    }

    .edu-title-group svg {
      font-size: 24px !important;
    }

    .edu-main {
      padding: 20px 12px;
      gap: 20px;
    }

    .edu-accordion-header {
      font-size: 13px;
      padding: 8px 14px;
    }

    .edu-accordion-arrow {
      font-size: 18px;
    }

    .edu-accordion-body {
      padding: 14px 12px;
      font-size: 14px;
    }
  }

  /* ── Extra small (≤ 360px) ── */
  @media (max-width: 360px) {
    .edu-title-group h2 {
      font-size: 15px;
    }

    .edu-accordion-header {
      font-size: 12px;
      padding: 6px 10px;
    }
  }
`;

function EducationPage() {
  const [openIndex, setOpenIndex] = useState(null);

  const toggle = (i) => {
    setOpenIndex(openIndex === i ? null : i);
  };

  const data = [
    {
      title: "1.Course Registration",
      content:
        "Robot Crisscross students' eligibility criteria, validate data and shortlist candidates to avoid related manual processes."
    },
    {
      title: "2.Timetable Updates",
      content:
        "Bot Notify students and faculties about meetings and events by sharing them automatic updates."
    },
    {
      title: "3.Grading Assessments",
      content:
        "RPA bots can be programmed in a rule-based framework for grading online assessments."
    },
    {
      title: "4.Attendance Management",
      content:
        "RPA bots can be programmed in a rule-based framework for grading online assessments."
    },
    {
      title: "5.Payroll Management",
      content:
        "RPAs used to monitor timely payment processing for all employees. It is helpful to use automated software to submit and process payroll in a timely manner."
    }
  ];

  return (
    <div>
      <style>{styles}</style>

      {/* ===== HEADER ===== */}
      <div className="edu-header">
        {/* LEFT */}
        <div
          className="edu-header-left"
          style={{ backgroundImage: `url(${bannerImg})` }}
        >
          <div className="edu-header-overlay" />

          <div className="edu-header-badge">
            <div className="edu-header-icon-box">
              <FaRobot style={{ color: "#fff", fontSize: "18px" }} />
            </div>

            <span>Robotic Process Automation - Use Cases</span>

            <span className="edu-arrow">›</span>
          </div>
        </div>

        {/* RIGHT */}
        <div className="edu-header-right">
          <div className="edu-triangle-left" />
          <div className="edu-triangle-right" />

          <div className="edu-title-group">
            <FaGraduationCap
              style={{
                fontSize: "32px",
                color: "#2fb7a4"
              }}
            />
            <h2>Education</h2>
          </div>
        </div>
      </div>

      {/* ===== MAIN SECTION ===== */}
      <div className="edu-main">
        {/* IMAGE */}
        <div className="edu-img-wrapper">
          <img src={educationImg} alt="Education" />
        </div>

        {/* ACCORDION */}
        <div className="edu-accordion">
          {data.map((item, i) => (
            <div key={i} className="edu-accordion-item">
              <div
                className="edu-accordion-header"
                onClick={() => toggle(i)}
              >
                {item.title}
                <span className="edu-accordion-arrow">
                  {openIndex === i ? "↑" : "⌄"}
                </span>
              </div>

              {openIndex === i && (
                <div className="edu-accordion-body">{item.content}</div>
              )}
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

export default EducationPage;
